import { render, staticRenderFns } from "./collectRecord.vue?vue&type=template&id=2bbcac66&scoped=true&"
import script from "./collectRecord.vue?vue&type=script&lang=js&"
export * from "./collectRecord.vue?vue&type=script&lang=js&"
import style0 from "./collectRecord.vue?vue&type=style&index=0&id=2bbcac66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbcac66",
  null
  
)

component.options.__file = "collectRecord.vue"
export default component.exports